<template>
  <div class="content-center none-click">
    <div class="banner">
        <div class="banner_box">
            <div class="banner_title">汇通数科渠道合作伙伴火热招募中</div>
            <div class="banner_text">开启新零售赛道掘金计划，打造区域明星品牌，携手合作共赢</div>
            <div class="banner_btn" @click="goAnchor('#join')">立即加入</div>
        </div>
        <img src="@/assets/Mobile/images/ecology/cooperate_banner.png" alt="">
    </div>
    <div class="solution">
        <div class="title">数智化赋能传统零售门店及企业客户转型升级</div>
        <!-- <div class="desc">
            提供全场景、全方位、全流程的数智化综合服务解决方案
        </div> -->
        <div class="menu menu_bg1">
            <div class="menu_title">千橙零售云</div>
            <div class="menu_text">零售门店数智化升级，助力经营增收提效</div>
            <div class="menu_box">
                <div class="box_item" @click="linkTo('QcErpSystem')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box1.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙ERP系统</div>
                        <div class="right_text">支持直营/联营/加盟多业态</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcCashier')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box2.png" alt="">
                    </div>
                    <div class="item_right" >
                        <div class="right_title">千橙收银系统</div>
                        <div class="right_text">半自动/自助一体机收单</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcChain')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box3.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙连锁系统</div>
                        <div class="right_text">支持直营/联营/加盟多业态</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcShopkeeper')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box4.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙新零售系统</div>
                        <div class="right_text">门店O2O一体化综合管理</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcAssociation')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box5.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">社群电商小程序系统</div>
                        <div class="right_text">社群团购分享小程序系统</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcShoppingMall')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box6.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙微商城系统</div>
                        <div class="right_text">社群电商小程序系统</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcMarketing')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box7.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙会员营销系统</div>
                        <div class="right_text">基于会员的SCRM系统</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu menu_bg2">
            <div class="menu_title">千橙电商云</div>
            <div class="menu_text">全链路电商能力覆盖，支持多种电商模式落地</div>
            <div class="menu_box">
                <div class="box_item" @click="linkTo('QcCommerce')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box8.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙电商S2B2C系统</div>
                        <div class="right_text">全链路全闭环交易系统</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcB2BChannel')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box9.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙电商B2b分销系统</div>
                        <div class="right_text">批发渠道多层级分销系统</div>
                    </div>
                </div>
                <div class="box_item" @click="linkTo('QcLiveBroadcast')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box10.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">汇好看直播系统</div>
                        <div class="right_text">视频号+小程序直播系统</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu menu_bg3">
            <div class="menu_title">千橙服务云</div>
            <div class="menu_text">AI+新场景，提升运营服务效率</div>
            <div class="menu_box1">
                <div class="box_item" @click="linkTo('QcTool')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box11.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙RPA工具箱</div>
                        <div class="right_text">机器人流程自动化服务</div>
                    </div>
                </div>
                <div class="box_item" style="margin-left: 10px;" @click="linkTo('QcDigit')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box12.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙数字人</div>
                        <div class="right_text">AI数字人直播助手</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menu menu_bg4">
            <div class="menu_title">千橙分销云</div>
            <div class="menu_text">打造“连接” +“提效”+“交易”的一站式智能分销平台</div>
            <div class="menu_box">
                <div class="box_item" @click="linkTo('QcDistribution')">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/home/box13.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">千橙分销</div>
                        <div class="right_text">基于企微的业务员分销系统</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    <div class="block02">
      <!-- <div class="sk-mobile-title">
        <div class="title">服务商收益模型</div>
      </div> -->
      <img src="@/assets/Mobile/images/ecology/cooperate05.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">我们对服务商的赋能</div>
        <div class="sub-title">十大保障体系，快速起步</div>
      </div>
      <img src="@/assets/Mobile/images/ecology/cooperate06.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">我们需要这样的服务商合作伙伴</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/ecology/cooperate07.png" alt="">
        <img src="@/assets/Mobile/images/ecology/cooperate08.png" alt="">
      </div>
    </div>
    <div id="join" class="join">
      <div class="sk-mobile-title">
        <div class="title">渠道合作商 期待您的加入</div>
      </div>
      <div class="process">
        <img src="@/assets/Mobile/images/ecology/cooperate_process.png" alt="">
      </div>
      <JoinForm />
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import JoinForm from '@/Mobile/Mobilecom/JoinForm'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
export default {
  metaInfo: metaInfo.Cooperate,
  components: {
    JoinForm,
    ContactForm,
    IndustrySolution
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    goAnchor(selector) { // 参数selector是id选择器（#anchor14）
        document.querySelector(selector).scrollIntoView({
            behavior: 'smooth'
        })
    },
    linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
  }
}
</script>

<style lang="less" scoped>
.banner_box{
    height:130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    .banner_title{
        width: 300px;
        height: 14px;
        font-size: 20px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        text-shadow: 0px 1px 1px rgba(14,15,120,0.17);
    }
    .banner_text{
        margin-top:18px;
        width: 195px;
        height: 30px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 15px;
        text-shadow: 0px 1px 1px rgba(15,23,135,0.29);
        text-align: center;
    }
    .banner_btn{
        margin-top:18px;
        width: 117px;
        height: 24px;
        border-radius: 3px;
        border: 1px solid #FFFFFF;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        text-align: center;
    }
}
.solution {
        padding: 30px 15px 0;
        .title {
          font-size: 20px;
          font-weight: 600;
          color: #595961;
          line-height: 28px;
        }
        .desc {
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #8B8FA1;
            line-height: 20px;
          text-align: center;
        }
        .menu_bg1{
            background: url('~@/assets/Mobile/images/home/menu1.png') no-repeat center;
            background-size: 100% 100%;
        }
        .menu_bg2{
            background: url('~@/assets/Mobile/images/home/menu2.png') no-repeat center;
            background-size: 100% 100%;
        }
        .menu_bg3{
            background: url('~@/assets/Mobile/images/home/menu3.png') no-repeat center;
            background-size: 100% 100%;
        }
        .menu_bg4{
            background: url('~@/assets/Mobile/images/home/menu4.png') no-repeat center;
            background-size: 100% 100%;
        }
        .menu{
            width: 100%;
            position: relative;
            margin-top:12px;
            padding: 14px 14px;
            .menu_title{
                height: 17px;
                font-size: 13px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 17px;
                text-align: left;
            }
            .menu_text{
                height: 14px;
                font-size: 7px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 10px;
                margin-top: 4px;
                text-align: left;
            }
            .menu_box1{
                width:100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .box_item{
                    width: 100px;
                    height: 29px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    display: flex;
                    flex-direction: row;
                    padding: 5px 5px;
                    margin-bottom:9px;
                    .item_left{
                        width: 12px;
                        img{
                            width: 12px;
                            height:11px;
                        }
                    }
                    .item_right{
                        text-align: left;
                        margin-left: 2px;
                        .right_title{
                            height: 10px;
                            font-size: 7px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            color: #333333;
                            line-height: 10px;
                        }
                        .right_text{
                            height: 8px;
                            font-size: 5px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            line-height: 8px;
                        }
                    }
                }
            }
            .menu_box{
                width:100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                .box_item{
                    width: 100px;
                    height: 29px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    display: flex;
                    flex-direction: row;
                    padding: 5px 5px;
                    margin-bottom:9px;
                    .item_left{
                        width: 12px;
                        img{
                            width: 12px;
                            height:11px;
                        }
                    }
                    .item_right{
                        text-align: left;
                        margin-left: 2px;
                        .right_title{
                            height: 10px;
                            font-size: 7px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            color: #333333;
                            line-height: 10px;
                        }
                        .right_text{
                            height: 8px;
                            font-size: 5px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            line-height: 8px;
                        }
                    }
                }
            }
        }
      }
.banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
}
.block01 {
  .content {
    padding: 34px 0 30px 0;
    display: flex;
    width: 375px;
    justify-content: space-evenly;
    align-items: flex-end;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 80px;
      span {
        margin-top: 19px;
        font-size: 9px;
        font-weight: 500;
        color: #595961;
        line-height: 13px;
      }
    }
    img {
      width: 49px;
    }
  }
}
.block02 {
  background-color: #FAFAFA;
  img {
    width: 348px;
    margin: 9px 0 19px 0;
  }
}
.block03 {
  img {
    width: 330px;
    margin: 7px 0 20px 0;
  }
}
.block04 {
  background-color: #FAFAFA;
  .content {
    margin: 12px 0 18px 0;
  }
  img {
    width: 333px;
    margin-bottom: 1px;
  }
}
.block06 {
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .item {
      margin-top: 7px;
      display: flex;
      flex-direction: column;
      // margin: 15px;
      font-size: 6px;
      line-height: 16px;
      color: #000000;
    }
    img {
      width: 106px;
      height: 52px;
    }
  }
}
.join {
  // height: 580px;
  background: url("~@/assets/Mobile/images/ecology/cooperate_form-bg.png") no-repeat center;
  background-size: 100% 100%;
  .title {
    color: #fff;
  }
  .process {
    width: 340px;
    height: 39px;
    margin: 20px auto 25px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
